import { useCallback, useEffect, useState } from "react";
import { useAccountV2ErrorHandling } from "./useAccountV2ErrorHandling.js";
import { RealCommerceError } from "../../../exceptions/realCommerceError.js";
import { useStores } from "../../../store/stores.js";
function useExpiredPaymentDeepLink(subscriptionUuid) {
    const { accountV2Store } = useStores();
    const handleError = useAccountV2ErrorHandling();
    const [isBusy, setIsBusy] = useState(false);
    const [isUpdated, setIsUpdated] = useState(false);
    const [error, setError] = useState();
    useEffect(()=>{
        if (!subscriptionUuid) {
            return;
        }
        setIsBusy(true);
        accountV2Store.fetchPaymentFailedDetails(subscriptionUuid).catch((e)=>{
            if (e instanceof RealCommerceError) {
                if (e.codes.length > 0) {
                    setError(e);
                } else {
                    handleError(e);
                }
            }
        }).finally(()=>setIsBusy(false));
    }, [
        subscriptionUuid
    ]);
    const markUpdated = useCallback(()=>setIsUpdated(true), []);
    return {
        isBusy,
        isUpdated,
        error,
        subscription: accountV2Store.expiredPaymentDetailsSubscription,
        hostnames: accountV2Store.expiredPaymentAffectedHostnames,
        markUpdated
    };
}
export { useExpiredPaymentDeepLink };
